import { ApplicationConfiguration } from '@src/core/application-configuration/application-configuration.type';
import { ApplicationConfigurationKeyEnum } from './application-configuration-key.enum';
import { ApplicationConfigurationContent, ApplicationConfigurationValue } from './types';

const createApplicationConfigurationService = async (
  initializer: (
    applicationConfigurationFileUrl?: string
  ) => Promise<ApplicationConfigurationContent>
) => {
  let storedConfiguration: ApplicationConfigurationContent = await initializer();

  return () => {
    const extendConfiguration = (configuration: ApplicationConfigurationContent): void => {
      storedConfiguration = { ...storedConfiguration, ...configuration };
    };

    const getConfiguration = (): ApplicationConfigurationContent => {
      const copyOfConfiguration: ApplicationConfigurationContent = JSON.parse(
        JSON.stringify(storedConfiguration)
      );
      return copyOfConfiguration;
    };

    const getValue = (key: ApplicationConfigurationKeyEnum): ApplicationConfigurationValue =>
      storedConfiguration[key];

    const getValues = (
      keys: ApplicationConfigurationKeyEnum[]
    ): Partial<ApplicationConfigurationContent> => {
      const configuration = {};
      keys.forEach((key: ApplicationConfigurationKeyEnum) => {
        configuration[key] = storedConfiguration[key];
      });
      return configuration;
    };

    return {
      extendConfiguration,
      getValue,
      getValues,
      getConfiguration,
    };
  };
};

const configurationInitializer = async (
  applicationConfigurationFileUrl: string = 'configuration/application-configuration.json'
): Promise<ApplicationConfigurationContent> => {
  const versioninedUrl = `${applicationConfigurationFileUrl}?v=${import.meta.env.VITE_CONFIG_HASH}`;
  const response: Response = await fetch(versioninedUrl);
  const configuration: ApplicationConfiguration = await response.json();

  return JSON.parse(JSON.stringify(configuration));
};

export const ApplicationConfigurationService = (
  await createApplicationConfigurationService(configurationInitializer)
)();
